import { Injectable } from '@angular/core';
import { Environment } from '../../../core/services/common';
import { isProduction, jsonStringify } from '../../utils/utils';

@Injectable({
  providedIn: 'root'
})
export class LogService {
  private static readonly INFO_TAG = '[INFO]';
  private static readonly DEBUG_TAG = '[DEBUG]';
  private static readonly WARNING_TAG = '[WARNING]';
  private static readonly ERROR_TAG = '[ERROR]';

  constructor(private env: Environment) {}

  i(thiss: any, message: string, ...optionalParams: any[]) {
    this.print(LogService.INFO_TAG, thiss, message, ...optionalParams);
  }

  d(thiss: any, message: string, ...optionalParams: any[]) {
    this.print(LogService.DEBUG_TAG, thiss, message, ...optionalParams);
  }

  w(thiss: any, message: string, ...optionalParams: any[]) {
    this.print(LogService.WARNING_TAG, thiss, message, ...optionalParams);
  }

  e(thiss: any, message: string, ...optionalParams: any[]) {
    this.print(LogService.ERROR_TAG, thiss, message, ...optionalParams);
  }

  logAndThrow(err: any, errorMsg?: string): never {
    this.w(this, errorMsg || '', err);
    throw new Error(errorMsg);
  }

  private async print(
    tag: string,
    thiss: any,
    message: any,
    ...optionalParams: any[]
  ) {
    await this.env.ready();
    const className =
      (!isProduction() && thiss?.constructor?.name) || '';
    let parsedMessage = '';
    if (typeof message === 'string') {
      parsedMessage = message;
    } else {
      if (message.message) {
        parsedMessage = message.message;
      } else {
        parsedMessage = jsonStringify(message);
      }
    }

    const payloadLog = optionalParams.length
      ? `\n\n ${optionalParams.map(jsonStringify).join(' ')}`
      : '';
    const log = [`${tag} ${className}: ${parsedMessage}`, payloadLog];
    switch (tag) {
      case LogService.ERROR_TAG:
        console.error(...log);
        break;
      case LogService.WARNING_TAG:
        console.warn(...log);
        break;
      case LogService.DEBUG_TAG:
        if (!isProduction()) {
          console.log(
            `${tag} ${className}: ${parsedMessage} \n\n`,
            ...optionalParams
          );
        }
        break;
      default:
        console.log(...log);
    }
  }
}
